import  { useRef, useState } from "react";
import { PaymentResultParams } from "../../../common/types";
import { Button } from "../Elements";
import { FaCopy, FaFilePdf } from "react-icons/fa";
import PaymentSlipModal from "../PaymentSlipModal";
import { toast } from "react-toastify";



interface Props extends PaymentResultParams {

}

const PaymentResult = (props: Props) => {
    const { Amount, ErrorCode, ErrorMessage, Installment, Orderid, PaymentId, ReferenceNumber, Status, TransactionId } = props;


    const paymentSlipModalRef = useRef<any>();
    const [isLoading, setIsLoading] = useState(false);
    const isSuccessPayment = Status == "success";
    const isErrorPayment = Status == "fail";
    const isWaitPayment = Status == "wait";

    var header = "Ödeme Başarılı!";
    var contenttext = "Ödemeniz başarılı bir şekilde alınmıştır. Ödeme bilgileri aşağıdaki gibidir.";
    if (isErrorPayment) {
        header = "Ödeme Başarısız!";
        contenttext = "Ödemeniz alınırken hata meydana gelmiştir. Hata bilgileri aşağıdaki gibidir.";
    }
    else if (isWaitPayment) {
        header = "Bankadan cevap bekleniyor!";
        contenttext = "Bankadan ödeme cevabı bekleniyor. Lütfen ödeme durumunu daha sonra tekrar kontrol ediniz.";
    }

    const getStatusImage = () => {

        if (isSuccessPayment) {
            return (
                <img width="70" height="70" src="/images/checked.png" />
            );
        }
        else if (isErrorPayment) {
            return (
                <img width="70" height="70" src="/images/basarisiz.svg" />
            );
        }
        else {
            return (
                <img width="70" height="70" src="/images/clockwise.png" />
            );
        }
    }
    const getInstallmentDesc = () => {

        let installment = 1;
        if (Installment > 0) {
            installment = Installment;
        }
        var installmentDesc = "Peşin";
        if (installment > 1) {
            installmentDesc = installment + " Taksit";
        }
        return installmentDesc;
    }

    const openPaymentSlip = () => {

        paymentSlipModalRef.current.showPaymentSlip({
            orderId: Orderid
        });
    }
    const copyTransactionId = () => {
        navigator.clipboard.writeText(TransactionId)
        toast.success("Değer başarılı bir şekilde kopyalandı");
    }
    const copyRefNo = () => {
        navigator.clipboard.writeText(ReferenceNumber)
        toast.success("Değer başarılı bir şekilde kopyalandı");
    }
    const getContentArea = () => {

        if (!isWaitPayment) {

            return (
                <div className="success-result-second-card">

                    <div className="top-left-reverse-radius">
                    </div>
                    <div className="top-right-reverse-radius">
                    </div>
                    {isSuccessPayment ? (
                        <>
                            <div className="flex justify-between">
                                <div className="result-page-label">
                                    Sipariş Numarası:
                                </div>
                                <div className="result-page-content flex items-center">
                                    {TransactionId}

                                    <FaCopy className="ml-2 cursor-pointer" onClick={copyTransactionId}></FaCopy>
                                </div>
                            </div>
                            <div className="flex justify-between mt-4">
                                <div className=" result-page-label">
                                    Banka Referans Kodu:
                                </div>
                                <div className="  result-page-content flex items-center">
                                    {ReferenceNumber}

                                    <FaCopy className="ml-2 cursor-pointer" onClick={copyRefNo}></FaCopy>

                                </div>
                            </div>
                            <div className="flex justify-between mt-4">
                                <div className=" result-page-label">
                                    Ödeme Tutarı:
                                </div>
                                <div className="  result-page-content">
                                    {Amount} ₺
                                </div>
                            </div>
                            <div className="flex justify-between mt-4">
                                <div className=" result-page-label">
                                    Taksit Sayısı:
                                </div>
                                <div className="  result-page-content">
                                    {getInstallmentDesc()}
                                </div>
                            </div>
                            <div className="justify-content-center align-items-center mt-5 text-center">

                                <Button
                                    type="submit"
                                    color="primary"
                                    hover="primary"
                                    className={" mt-6 px-7 py-3"}
                                    size="xl"
                                    callback={openPaymentSlip}
                                    loading={isLoading}

                                >
                                    <span className="mr-2">Ödeme Dekontu </span>
                                    {/* <img className="h-6"  src='/images/pdf-logo.png' /> */}
                                    <FaFilePdf size={25}></FaFilePdf>
                                </Button>

                            </div>
                        </>
                    ) : (
                        <>
                            <div className="flex justify-between">
                                <div className="col-4 result-page-label">
                                    Hata Kodu:
                                </div>
                                <div className="col-8  result-page-content">
                                    {ErrorCode}

                                </div>
                            </div>
                            <div className="flex justify-between mt-4">
                                <div className="col-4 result-page-label">
                                    Hata Mesajı:
                                </div>
                                <div className="col-8  result-page-content">
                                    {ErrorMessage}


                                </div>
                            </div>
                        </>
                    )}


                </div>
            );
        }
        return null
    }

    return (
        <div className="justify-center mt-14 flex flex-col mb-32 " >

            <PaymentSlipModal ref={paymentSlipModalRef} isLoading={isLoading} setIsLoading={setIsLoading}></PaymentSlipModal>

            <div className="success-result-first-card">
                <div className="flex items-center w-full justify-center">
                    {getStatusImage()}
                </div>


                <h2 className="payment-success-header">{header}</h2>
                <p className="payment-result-content">{contenttext}</p>
                <div className="left-reverse-radius">
                </div>
                <div className="right-reverse-radius">
                </div>
            </div>

            {getContentArea()}


        </div>
    );
}
export default PaymentResult